import {
  NAVIGATION_GO,
  NAVIGATION_NEXT,
  NAVIGATION_PREVIOUS,
} from "../actions/navigation";
import {
  RETRY as DOCUMENT_CAPTURE_RETRY,
  PREVIEW as DOCUMENT_CAPTURE_PREVIEW,
} from "../actions/documentCapture";
import {
  RETRY as FACE_CAPTURE_RETRY,
  PREVIEW as FACE_CAPTURE_PREVIEW,
} from "../actions/faceCapture";
import { RETRY as LIVENESS_TEST_RETRY } from "../actions/livenessTest";
import {
  DOCUMENT_CAPTURE_CONFIRM,
  FACE_CAPTURE_CONFIRM,
  FACE_CAPTURE,
  DOCUMENT_CAPTURE_INSTRUCTIONS,
  INSTRUCTIONS_CLR,
  INSTRUCTIONS_FACE_LIVENESS_3D,
  INTRO_PAGE,
} from "../enums/pages";
import { previous, next } from "../steps";
import { SVR3DFL } from "../enums/livenessTestType";

const defaultState = {
  page: INTRO_PAGE,
};

export function navigation(state = defaultState, action) {
  switch (action.type) {
    case NAVIGATION_GO:
      return {
        ...state,
        page: action.payload,
      };
    case NAVIGATION_PREVIOUS:
      return {
        ...state,
        page: previous(state.page),
      };
    case NAVIGATION_NEXT:
      return {
        ...state,
        page: next(state.page),
      };
    case LIVENESS_TEST_RETRY:
      return {
        ...state,
        page:
          action.payload === SVR3DFL
            ? INSTRUCTIONS_FACE_LIVENESS_3D
            : INSTRUCTIONS_CLR,
      };
    case DOCUMENT_CAPTURE_PREVIEW:
      return {
        ...state,
        page: DOCUMENT_CAPTURE_CONFIRM,
      };
    case DOCUMENT_CAPTURE_RETRY:
      return {
        ...state,
        page: DOCUMENT_CAPTURE_INSTRUCTIONS,
      };
    case FACE_CAPTURE_PREVIEW:
      return {
        ...state,
        page: FACE_CAPTURE_CONFIRM,
      };
    case FACE_CAPTURE_RETRY:
      return {
        ...state,
        page: FACE_CAPTURE,
      };

    default:
      return state;
  }
}
